module.exports = __webpack_public_path__ + "static/media/AMX-Medium.0b08e28f.woff2";